import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import router1 from './assets/images/router1.png';
import router2 from './assets/images/router2.png';
import router3 from './assets/images/router3.png';
import router4 from './assets/images/router4.png';
import router5 from './assets/images/router5.png';
import router6 from './assets/images/router6.png';
import router from './assets/videos/router.mp4';


const ReactLesson10 = () => {
  const [language, changeLanguage] = useState("react");
  const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
      yarn react-router-dom

      `
    );

    const code1 = (
      'text',
      `
      "dependencies"; {
        "@testing-library/jest-dom"; "^5.17.0",
        "@testing-library/react"; "^13.4.0",
        "@testing-library/user-event"; "^13.5.0",
        "react"; "^18.2.0",
        "react-dom"; "^18.2.0",
        "react-router-dom"; "^6.15.0", //React Router
        "react-scripts"; "5.0.1",
        "web-vitals"; "^2.1.4"
      },

      `
    );

    const code2 = (
      'text',
      `
      import React from 'react';
      import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
      import Home from '../App';
      import About from '../About';
      import Contact from '../Contact';

      const Routescreen = () => {
        return(
          <Router>
          <div>
          <Routes>
          <Route exact path="/contact" element={<contact />} />
          <Route exact path="/about" element={<about />} />
          <Route exact path="/" element={<Home />} />
          </Router>
        )
      }

      export default RouteScreen;

      `
    );
    const code3 = (
      'text',
      `
      import React from 'react';

      const About = () => {
        return(
          <div>
          <h1>About us</h1>
          </div>
        )
      }
      
      export default About;

      `
    );
    const code4 = (
      'text',
      `
      import React from 'react';

      const Contact = () => {
        return(
          <div>
          <h1>Contact us</h1>
          </div>
        )
      }
      
      export default Contact;

      `
    );
    const code5 = (
      'text',
      `
      import React from 'react';
      import { Link } from 'react-router-dom';
      const App = () => {

        return (
          <div>
          <span><Link to="/">Home </Link></span>
          <span><Link to="/about">About </Link></span>
          <span><Link to="/contact">Contact </Link></span>
          </div>
        );
      }

      export default App;

     
      `
    );


  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    
    <div className="alert alert-secondary" role="alert">
    <h3><strong>What is React Router?</strong></h3>
      <p>React Router is a routing library for React applications. It provides a way to handle routing in a single-page web application by allowing developers to define different routes and their corresponding components, allowing for the rendering of different components based on the URL.</p>
      <p>You see, unlike the way traditional routing works in HTML where you use anchor tags to redirect pages, that procedure will not work with React. You will need to use a routing library as we shall soon see. </p>
      <h4><strong>Key Features of React Router</strong></h4>
      <ol class="list-group list-group-numbered mb-4">
          <li class="list-group-item"><strong>Declarative Routing:</strong> React Router uses a declarative approach, allowing developers to define routes using JSX elements, making it intuitive and easy to understand.</li>
          <li class="list-group-item"><strong>Nested Routing:</strong> It supports nested routes, allowing you to render components hierarchically based on the URL.</li>
          <li class="list-group-item"><strong>Dynamic Routing:</strong> React Router enables dynamic routing by using URL parameters, allowing components to access specific data based on the URL.</li>
          <li class="list-group-item"><strong>Route Matching:</strong> It provides various ways to match routes, including exact matching, partial matching, or custom matching, giving developers flexibility in defining how routes should be matched.</li>
          <li class="list-group-item"><strong>History Management:</strong> React Router interacts with the browser's history API, allowing for navigation between different URLs and keeping UI in sync with the URL.</li>
      </ol>
      <p>In the next lesson we shall see how to use the React Router in our project.</p>
      <h3>React Router Example</h3>
   <p>To get started with React Router, we need to first install the dependency from <strong>react-router-dom</strong></p>
   <p>So, go to the root of your project in the terminal or command prompt and type the following:</p>

   <CopyBlock
                        language={"bash"}
                        text={code} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      /> 

                      <p>To verify that the dependency was added successfully, go to your <strong>package.json file</strong>, you should see the <strong>react-router-dom</strong> dependency with its installed version as follows:</p>
<CopyBlock
                        language={"react"}
                        text={code1} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      /> 
                           <p>Next, we are going to create a file inside a folder called <strong>routes</strong> and add both our Router and components. We will call this created file <strong>RouteScreen.js</strong></p>
   <h4><strong>RouterScreen.js</strong></h4>
   <CopyBlock
                        language={"react"}
                        text={code2} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />      <p>Now a few things to explain here:</p>
   <pre><strong>&lt;Route exact path="/" element={'&lt;App /&gt;'} /&gt;</strong></pre>
   <p>This route is usually referred to as the default homepage. It's the page that shows up when the url is first loaded and is usually depicted with a <strong>"/"</strong></p>
   <p>You will also notice that the other pages like <strong>About, Contact, etc</strong> are all imported accordingly. So we will create the different files</p>
   <h4 class="text-dark">About.js</h4>
   <CopyBlock
                        language={"react"}
                        text={code3} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />      <h4><strong>Contact.js</strong></h4>
<CopyBlock
                        language={"react"}
                        text={code4} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />      <h4><strong>App.js</strong></h4>
<CopyBlock
                        language={"react"}
                        text={code5} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />      <video controls class="mb-4" style={{width: '500px', height: '350px'}}>
      <source src={router} type="video/mp4" />
      Your browser does not support HTML5 video.
    </video>
    <p>This is just a basic HTML as we haven't done any styling yet.  The <strong>&lt;Link&gt;</strong> component is used to navigate between different routes within the application.</p>
    <h3><strong>Summary</strong></h3>
    <p>React Router simplifies the process of handling navigation and displaying different components based on the URL in React applications.</p>
     </div>
  

      </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson10
  